export default __webpack_public_path__ + "static/circleback-c11cef1bd4f9d40abc4da3a90b73c847.png";